import { ReactElement } from 'react';

import { ConfidentialResourceType } from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';
import { Query } from '@dreryk/command-query-api';

import { ConfidentialAccessPendingButton } from './ConfidentialAccessPendingButton';
import { ConfidentialAccessRequestButton } from './ConfidentialAccessRequestButton';

type ConfidentialAccessAwareEntry = {
   readonly id: number;
   readonly confidential: boolean;
   readonly hasAccess: boolean;
   readonly pendingAccessRequest: boolean;
};

type GetConfidentialAccessButtonOptions = {
   readonly resourceType: ConfidentialResourceType;
   readonly refetchQuery: new () => Query<unknown>;
};

export const getConfidentialAccessButton = (
   entry: ConfidentialAccessAwareEntry,
   options: GetConfidentialAccessButtonOptions
): ReactElement | null => {
   if (!entry.confidential || entry.hasAccess) {
      return null;
   }

   if (entry.pendingAccessRequest) {
      return <ConfidentialAccessPendingButton />;
   }

   return (
      <ConfidentialAccessRequestButton
         resourceId={entry.id}
         resourceType={options.resourceType}
         refetchQuery={options.refetchQuery}
      />
   );
};

export const isConfidentialHiddenEntry = (entry: {
   readonly confidential: boolean;
   readonly hasAccess: boolean;
}): boolean => entry.confidential && !entry.hasAccess;
